import Toast from 'muse-ui-toast'

export function isPhone (phone) {
  return /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/.test(phone)
}

export function isIOS () {
  return navigator.userAgent.match(/iphone|ipad|ipod/i)
}

export function isWeixin () {
  return navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1
}

export function isMobile () {
  return !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/)
}

const u = navigator.userAgent
export const browser = {
  mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
  android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或者uc浏览器
  ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
  weixin: u.indexOf('MicroMessenger') > -1, // 是否微信
  QQ: u.indexOf('QQ') > -1, // 是否QQ内核浏览器
  xiaomi: u.indexOf('MiuiBrowser') > -1, // 是否小米浏览器
  baidu: u.indexOf('baidubrowser') > -1, // 是否百度浏览器
  UC: u.indexOf('UCBrowser') > -1, // 是否UC
  safari: u.indexOf('Safari') > -1 // 用于检测是否苹果桌面模式（是为0）
}

export function validate (list) {
  let status = list.every((item) => {
    if (!item.options) {
      if (!item.val) {
        Toast.error(item.msg)
        return false
      }
    }
    if (item.options && typeof item.options === 'object' && item.options.id === 885) {
      if (!item.val) {
        Toast.error('请输入微信验证码')
        return false
      }
    }
    if (item.options === 'phone') {
      if (!item.val) {
        Toast.error('手机号不能为空')
        return false
      }
      if (!isPhone(item.val)) {
        Toast.error('请输入正确的手机号')
        return false
      }
    }
    if (item.options === 'same') {
      if (item.val[0] !== item.val[1]) {
        Toast.error('两次密码不一致')
        return false
      }
    }
    if (item.options === 'noSame') {
      if (item.val[0] === item.val[1]) {
        Toast.error('新旧密码不能一样')
        return false
      }
    }
    if (item.options === 'feCode' && item.id === 885) {
      if (item.val[0].toLowerCase() !== item.val[1].toLowerCase()) {
        Toast.error('请输入正确的验证码')
        return false
      }
    }
    return true
  })
  return status
}

// iPhone X、iPhone XS
const isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812
// iPhone XS Max
const isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896
// iPhone XR
const isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896

export function isIOSBangs () {
  if (isIOS && (isIPhoneX || isIPhoneXSMax || isIPhoneXR)) {
    return true
  } else {
    return false
  }
}
